

const state = {
  error: false,
  manualCalculation: false,
  notAllData: false,
};

const getters = {
  getError(st) {
    return st.error;
  },
  getManualCalculation(st) {
    return st.manualCalculation;
  },
  getNotAllData(st) {
    return st.notAllData;
  },
};

const mutations = {
  setError(st, value) {
    st.error = value;
  },
  setManualCalculation(st, value) {
    st.manualCalculation = value;
  },
  setNotAllData(st, value) {
    st.notAllData = value;
  },
};
const actions = {
  async setError({ commit }, error) {
    commit('setError', error);
  },
  async setManualCalculation({ commit }, error) {
    commit('setManualCalculation', error);
  },
  async setNotAllData({ commit }, error) {
    commit('setNotAllData', error);
  },
};


export default {
  state,
  mutations,
  getters,
  actions,
};
